module.exports = __webpack_public_path__ + "img/ic_profile_wizard_social_profiles.6aaa3e86.svg";